import { apiRequest } from '../client';
import { getApiToken, tryGetApiToken } from '../authToken';
import { toJsonSafe } from '../json';

export async function lookupStorefrontGlobalUser({ email, companyId } = {}) {
  const params = new URLSearchParams();
  if (email) params.set('email', String(email).trim().toLowerCase());
  if (companyId) params.set('companyId', companyId);
  const query = params.toString();
  return apiRequest(`/api/storefront/global-users/lookup${query ? `?${query}` : ''}`);
}

export async function grantStorefrontCompanyAccess({ email, userId, companyId } = {}) {
  return apiRequest('/api/storefront/global-users/grant-access', {
    method: 'POST',
    body: { email, userId, companyId },
  });
}

export async function getStorefrontGlobalUserMe({ token } = {}) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest('/api/storefront/global-users/me', { token: authToken });
  return result.user;
}

export async function getStorefrontGlobalUserMeOrNull({ token } = {}) {
  try {
    return await getStorefrontGlobalUserMe({ token });
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function upsertStorefrontGlobalUser({ companyId, user, token } = {}) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest('/api/storefront/global-users/me', {
    token: authToken,
    method: 'PUT',
    body: { companyId, user: toJsonSafe(user) },
  });
  return result.user;
}

export async function patchStorefrontGlobalUserProfile({ companyId, profile, token } = {}) {
  const authToken = token || (await getApiToken());
  const result = await apiRequest('/api/storefront/global-users/me', {
    token: authToken,
    method: 'PATCH',
    body: { companyId, profile: toJsonSafe(profile) },
  });
  return result.user;
}

export async function addStorefrontCompanyAccessMe({ companyId, token } = {}) {
  const authToken = token || (await tryGetApiToken());
  if (authToken) {
    const result = await apiRequest('/api/storefront/global-users/me/companies', {
      token: authToken,
      method: 'POST',
      body: { companyId },
    });
    return result.user;
  }
  return null;
}

export async function recordStorefrontLastLogin({ companyId, token } = {}) {
  const authToken = token || (await getApiToken());
  return apiRequest('/api/storefront/global-users/me/last-login', {
    token: authToken,
    method: 'POST',
    body: { companyId },
  });
}
